import { render, staticRenderFns } from "./CardTimestampFooter.vue?vue&type=template&id=9d2f8e16&scoped=true"
import script from "./CardTimestampFooter.vue?vue&type=script&lang=js"
export * from "./CardTimestampFooter.vue?vue&type=script&lang=js"
import style0 from "./CardTimestampFooter.scss?vue&type=style&index=0&id=9d2f8e16&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2f8e16",
  null
  
)

export default component.exports